export default __webpack_public_path__ + "static/media/V360_SOV.eb64a5da.pdf";